import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import PitchTypeAnalysisPage from './pages/PitchTypeAnalysisPage';
import PitcherScoutingReports from './pages/PitcherScoutingReports';
import HitterReportsPage from './pages/HitterReportsPage';
import PitcherDevelopmentPlans from './pages/PitcherDevelopmentPlans';
import HitterDevelopmentPlans from './pages/HitterDevelopmentPlans';
import HomePage from './pages/HomePage';
import NavBar from './components/layout/NavBar';
import { ErrorBoundary } from './components/system/ErrorBoundary';
import { ProfessionalThemeProvider } from './components/ui/ProfessionalThemeProvider';
import { 
  ProfessionalPageContainer, 
  ProfessionalSpinner
} from './components/ui/ProfessionalComponents';
import './styles/globals.css';
import './styles/overrides.css';

// Code-split heavy pages - Elite 8 Only
const PitchingOverviewPage = lazy(() => import('./pages/PitchingOverview'));
const HittingOverviewPage = lazy(() => import('./pages/HittingOverviewPage'));
const SprayChartsPage = lazy(() => import('./pages/SprayChartsPage'));
const MLBCommandCenter = lazy(() => import('./pages/MLBCommandCenter'));


export default function App() {
  return (
    <ErrorBoundary>
      <ProfessionalThemeProvider>
        <Router>
          <NavBar />
          <Suspense fallback={
            <ProfessionalPageContainer>
              <div className="flex items-center justify-center min-h-screen">
                <ProfessionalSpinner size="xl" />
              </div>
            </ProfessionalPageContainer>
          }>
            <Routes>
              {/* HOME */}
              <Route path="/" element={<HomePage />} />

              {/* ELITE SHOWCASE ROUTES */}
              
              {/* Parent paths redirect to primary child pages */}
              <Route path="/pitching" element={<Navigate to="/pitching/overview" replace />} />
              <Route path="/hitting" element={<Navigate to="/hitting/overview" replace />} />
              <Route path="/players" element={<Navigate to="/" replace />} />

              {/* PITCHING ANALYSIS - Elite 4 Pages */}
              <Route path="/pitching/overview" element={<PitchingOverviewPage />} />
              <Route path="/pitching/types" element={<PitchTypeAnalysisPage />} />
              <Route path="/pitching/scouting-reports" element={<PitcherScoutingReports />} />

              {/* HITTING ANALYSIS - Elite 3 Pages */}
              <Route path="/hitting/overview" element={<HittingOverviewPage />} />
              <Route path="/hitting/reports" element={<HitterReportsPage />} />
              <Route path="/hitting/spray-charts" element={<SprayChartsPage />} />

              {/* MLB OPERATIONS LAB */}
              <Route path="/mlb-ops/command-center" element={<MLBCommandCenter />} />

              {/* PLAYER DEVELOPMENT PLANS */}
              <Route path="/pitcher-development-plans" element={<PitcherDevelopmentPlans />} />
              <Route path="/hitter-development-plans" element={<HitterDevelopmentPlans />} />


              {/* REMOVED: Organization page - focusing on Elite 9 analytics showcase */}

              {/* LEGACY REDIRECTS - Keep for existing bookmarks */}
              <Route path="/pitching/pitch-control-movement" element={<Navigate to="/pitching/overview" replace />} />
              <Route path="/pitching/control" element={<Navigate to="/pitching/overview" replace />} />
              <Route path="/pitching/mlb-benchmarks" element={<Navigate to="/pitching/overview" replace />} />
              <Route path="/hitting/mlb-benchmarks" element={<Navigate to="/hitting/overview" replace />} />
              <Route path="/pitching/pro-comps" element={<Navigate to="/pitching/scouting-reports" replace />} />
              <Route path="/pitching/reports" element={<Navigate to="/pitching/scouting-reports" replace />} />
              <Route path="/pitching/arsenals" element={<Navigate to="/pitching/scouting-reports" replace />} />
              <Route path="/hitting/performance" element={<Navigate to="/hitting/overview" replace />} />
              <Route path="/hitting/performance-results" element={<Navigate to="/hitting/overview" replace />} />
              <Route path="/hitting/batted-ball" element={<Navigate to="/hitting/overview" replace />} />
              <Route path="/players/profiles" element={<Navigate to="/" replace />} />
              <Route path="/players/roster" element={<Navigate to="/" replace />} />
              
            </Routes>
          </Suspense>
        </Router>
      </ProfessionalThemeProvider>
    </ErrorBoundary>
  );
}